<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <div class="relative w-full" @click="handleDropdownClick">
            <div @click="toggleDropdown" :class="[
                'flex items-center border z-10 rounded-lg',
                disabled ? 'bg-gray-100 cursor-not-allowed' : 'border-blue-400 cursor-pointer',
                floatingLabel ? 'px-3 py-2' : 'p-4',
                { 'bg-gray-100': isOpen } // Tambahkan class dinamis di sini
            ]">
                <span v-if="iconFront" class="mr-2">
                    <AppIcon :icon="iconFront" :class="[
                        disabled ? 'text-gray-400' : 'text-gray-600'
                    ]"
                     width="20" height="20" />
                </span>
                <div class="flex flex-col flex-grow">
                    <label v-if="floatingLabel" :class="labelClass">{{ floatingLabel }}</label>
                    <span :class="[
                        disabled ? 'text-gray-400' : 'text-gray-600'
                    ]">{{ displayedCount }} {{ guestCounts[0].label }}</span>
                </div>
                <span class="ml-auto">
                    <AppIcon icon="mdi:chevron-down" class="text-gray-600 w-4 h-4" />
                </span>
            </div>

            <div v-if="isOpen" class="absolute z-10 mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg p-4">
                <div v-for="(option, index) in guestCounts" :key="option.label" :class="[
                    'flex justify-between p-2 items-center',
                    { 'border-t border-gray-200': index > 0 },
                ]">
                    <span>{{ option.label }}</span>
                    <div class="flex items-center">
                        <button @click="decrement(index)" type="button" class="text-gray-600" :disabled="option.count <= 0">
                            <AppIcon :icon="option.count <= 0
                                ? 'mdi:minus-circle-outline'
                                : 'mdi:minus-circle'
                                " />
                        </button>
                        <span class="mx-2 w-6 text-center">{{ option.count }}</span>
                        <!-- Tambahkan lebar tetap pada count -->
                        <button @click="increment(index)" type="button" class="text-gray-600" :class="{ 'opacity-50 cursor-not-allowed': displayedCount >= maxCount }" :disabled="displayedCount >= maxCount">
                            <AppIcon icon="mdi:plus-circle" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseSelector",
    props: {
        label: { type: String, default: "" },
        floatingLabel: { type: String, default: "" },
        labelClass: {
            type: String,
            default: "text-sm text-blue-500 font-medium",
        },
        options: { type: Array, required: true },
        iconFront: { type: String, default: "" },
        modelValue: { type: Object, default: () => ({}) },
        maxCount: { type: Number, default: 2 },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            isOpen: false,
            guestCounts: this.options.map((option) => ({
                ...option,
                count: this.modelValue[option.label.toLowerCase()] || 0,
            })), // Initialize counts based on modelValue
        };
    },
    computed: {
        displayedCount() {
            return this.guestCounts.reduce(
                (total, option) => total + option.count,
                0
            );
        },
    },
    methods: {
        toggleDropdown() {
            if (this.disabled) {
                return;
            }
            if (!this.isOpen) {
                this.guestCounts = this.options.map((option) => ({
                    ...option,
                    count: this.modelValue[option.label.toLowerCase()] || 2,
                }));
            }
            this.isOpen = !this.isOpen;
        },
        handleDropdownClick(event) {
            if (this.disabled) {
                return;
            }
            // Cek apakah elemen yang di-klik berada di luar dropdown
            const target = event.target;
            if (this.isOpen && !this.$el.contains(target)) {
                this.isOpen = false; // Tutup dropdown jika klik di luar
            }
        },
        increment(index) {
            const total = this.displayedCount; // Hitung total saat ini
            if (total < this.maxCount) { // Hanya tambahkan jika total < maxCount
                this.guestCounts[index].count += 1;
                this.emitUpdatedCounts();
            }
        },
        decrement(index) {
            if (this.guestCounts[index].count > 0) {
                this.guestCounts[index].count -= 1; // Decrement the count
                this.emitUpdatedCounts(); // Emit setiap kali ada perubahan
            }
        },
        emitUpdatedCounts() {
            const updatedCounts = {};
            this.guestCounts.forEach((option) => {
                updatedCounts[option.label.toLowerCase()] = option.count;
            });
            this.$emit("update:modelValue", updatedCounts);
        },
    },
    watch: {
        modelValue: {
            handler(newVal) {
                this.guestCounts = this.options.map((option) => ({
                    ...option,
                    count: newVal[option.label.toLowerCase()] || 2,
                }));
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        document.addEventListener("click", this.handleDropdownClick); // Tambahkan listener saat komponen di-mount
    },
    unmounted() {
        document.removeEventListener("click", this.handleDropdownClick); // Hapus listener saat komponen di-destroy
    },
};
</script>

<style scoped>
.relative {
    z-index: 50;
    /* Ensure dropdown is above other elements */
}
</style>
